(() => {
  const labels = document.querySelector('[data-emberose-gallery-navigation]')?.dataset;
  const bindSwipe = (surface, move, enabled = () => true) => {
    let gesture = null;
    let suppressClickUntil = 0;
    const reset = () => { gesture = null; };
    const overVideoControls = (target, y) => {
      const video = target.closest('video');
      return video && y > video.getBoundingClientRect().bottom - 56;
    };
    const track = (x, y, event) => {
      const dx = x - gesture.x;
      const dy = y - gesture.y;
      if (!gesture.horizontal && Math.abs(dy) > 12 && Math.abs(dy) >= Math.abs(dx)) { reset(); return; }
      if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        if (!gesture.horizontal) {
          gesture.horizontal = true;
          if (gesture.kind === 'pointer') surface.setPointerCapture(gesture.id);
        }
        if (event.cancelable !== false) event.preventDefault();
      }
    };
    const finish = (x, y) => {
      const dx = x - gesture.x;
      const dy = y - gesture.y;
      const horizontal = gesture.horizontal;
      reset();
      if (horizontal) suppressClickUntil = Date.now() + 400;
      if (horizontal && Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.4 && enabled()) move(dx < 0 ? 1 : -1);
    };
    // Safari and in-app browsers can cancel pointer capture during a touch.
    // Handle native touches directly; pointer handlers remain for mouse/pen
    // and browsers that expose touch only through Pointer Events.
    surface.addEventListener('touchstart', (event) => {
      reset();
      if (event.touches.length !== 1 || !enabled()) return;
      const touch = event.touches[0];
      if (overVideoControls(event.target, touch.clientY)) return;
      gesture = { kind: 'touch', id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false };
    }, { passive: true });
    surface.addEventListener('touchmove', (event) => {
      if (gesture?.kind !== 'touch') return;
      if (event.touches.length !== 1 || !enabled()) { reset(); return; }
      const touch = Array.from(event.touches).find(item => item.identifier === gesture.id);
      if (touch) track(touch.clientX, touch.clientY, event);
    }, { passive: false });
    surface.addEventListener('touchend', (event) => {
      if (gesture?.kind !== 'touch') return;
      const touch = Array.from(event.changedTouches).find(item => item.identifier === gesture.id);
      if (touch) finish(touch.clientX, touch.clientY);
    });
    surface.addEventListener('touchcancel', () => { if (gesture?.kind === 'touch') reset(); });
    surface.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' && typeof TouchEvent !== 'undefined') return;
      if (!event.isPrimary || gesture) { reset(); return; }
      if (event.button !== 0 || !enabled() || overVideoControls(event.target, event.clientY)) return;
      gesture = { kind: 'pointer', id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
    });
    surface.addEventListener('pointermove', (event) => {
      if (gesture?.kind === 'pointer' && gesture.id === event.pointerId) track(event.clientX, event.clientY, event);
    });
    surface.addEventListener('pointerup', (event) => {
      if (gesture?.kind === 'pointer' && gesture.id === event.pointerId) finish(event.clientX, event.clientY);
    });
    surface.addEventListener('pointercancel', (event) => {
      if (gesture?.kind === 'pointer' && gesture.id === event.pointerId) reset();
    });
    surface.addEventListener('lostpointercapture', (event) => {
      if (event.target === surface && gesture?.kind === 'pointer' && gesture.id === event.pointerId) reset();
    });
    surface.addEventListener('pointerleave', () => { if (gesture?.kind === 'pointer' && !gesture.horizontal) reset(); });
    surface.addEventListener('dragstart', (event) => event.preventDefault());
    surface.addEventListener('click', (event) => {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
  };
  const initialise = (root) => {
    root.querySelectorAll('[class*="ai-gift-card-gallery-main-"]').forEach((main) => {
      if (main.dataset.swipeReady) return;
      const choices = Array.from(main.parentElement.querySelectorAll('button[data-design-image]'));
      if (choices.length < 2) return;
      main.dataset.swipeReady = 'true';
      main.classList.add('emberose-swipe-surface', 'emberose-gift-card-swipe');
      bindSwipe(main, direction => {
        const available = choices.filter(button => !button.hidden && !button.disabled && getComputedStyle(button).display !== 'none');
        if (available.length < 2) return;
        const current = available.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        available[(current + direction + available.length) % available.length].click();
      });
    });
    root.querySelectorAll('.product-gallery').forEach((gallery) => {
      if (gallery.dataset.swipeReady) return;
      const main = gallery.querySelector('.product-gallery__main');
      const thumbs = Array.from(gallery.querySelectorAll('.product-gallery__thumbnail'));
      const panels = Array.from(gallery.querySelectorAll('.product-gallery__panel'));
      if (!main || !thumbs.length || thumbs.length !== panels.length) return;
      gallery.dataset.swipeReady = 'true';
      const page = gallery.closest('.product-page');
      if (page?.dataset.incomingGalleryEnabled === 'false') {
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
          panels.forEach((panel, i) => {
            panel.hidden = i !== index;
            panel.classList.toggle('is-active', i === index);
            if (i !== index) panel.querySelectorAll('video').forEach(video => video.pause());
          });
          thumbs.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-pressed', String(i === index)); });
        }));
      }
      if (thumbs.length > 1) {
        main.classList.add('emberose-swipe-surface');
        bindSwipe(main, (direction) => {
          const available = thumbs.filter(thumb => !thumb.hidden && !thumb.disabled && getComputedStyle(thumb).display !== 'none');
          if (available.length < 2) return;
          const current = available.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true');
          available[(current + direction + available.length) % available.length].click();
        });
      }
      const dialog = gallery.querySelector('dialog') || page?.querySelector('[data-everelle-lightbox], [data-tessa-lightbox]');
      if (!dialog) return;
      const viewport = dialog.querySelector('[data-gallery-viewport], [data-everelle-viewport], [data-tessa-viewport]') || dialog.querySelector('.product-gallery__lightbox-image');
      const image = dialog.querySelector('.product-gallery__lightbox-image');
      const openers = Array.from(gallery.querySelectorAll('[data-gallery-open-image], [data-everelle-enlarge], [data-tessa-enlarge]'));
      const level = dialog.querySelector('[data-gallery-zoom-level], [data-everelle-zoom-level], [data-tessa-zoom-level]');
      if (!viewport || !image || !openers.length) return;
      dialog.classList.add('emberose-media-viewer');
      viewport.classList.add('emberose-media-viewport');
      const shell = dialog.querySelector('.product-gallery__lightbox-shell');
      const fit = dialog.querySelector('[data-gallery-fit], [data-everelle-fit], [data-tessa-fit]');
      const zoomIn = dialog.querySelector('[data-gallery-zoom-in], [data-everelle-zoom-in], [data-tessa-zoom-in]');
      const zoom = document.createElement('button');
      zoom.type = 'button';
      zoom.className = 'emberose-viewer-zoom';
      zoom.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5M7.5 10.5h6"/><path d="M10.5 7.5v6" class="emberose-zoom-plus"/></svg>';
      zoom.addEventListener('click', () => {
        if (atFit()) { zoomIn?.click(); zoomIn?.click(); } else fit?.click();
      });
      if (fit && zoomIn) shell.append(zoom);
      const original = dialog.querySelector('[data-gallery-original], [data-everelle-full-image], [data-tessa-full-image]');
      if (original) {
        original.className = 'emberose-viewer-original';
        original.setAttribute('aria-label', 'Open original image in a new tab');
        original.title = 'Open original image';
        original.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M10 5H5v14h14v-5"/></svg>';
        shell.append(original);
      }
      const status = document.createElement('div');
      status.className = 'emberose-viewer-status';
      const count = document.createElement('span');
      count.setAttribute('aria-live', 'polite');
      const hint = document.createElement('span');
      hint.className = 'emberose-viewer-hint';
      status.append(count, hint);
      shell.append(status);
      const updateStatus = () => {
        if (original) original.href = image.src;
        const current = openers.findIndex(opener => new URL(opener.dataset.galleryImage || opener.dataset.image, document.baseURI).href === image.src);
        count.textContent = `${Math.max(current + 1, 1)} / ${openers.length}`;
        hint.textContent = atFit() ? (openers.length > 1 ? 'Swipe to explore' : '') : 'Drag to explore · tap zoom to fit';
        zoom.setAttribute('aria-label', atFit() ? (zoomIn?.getAttribute('aria-label') || 'Zoom image') : (fit?.textContent.trim() || 'Fit image'));
        zoom.setAttribute('aria-pressed', String(!atFit()));
        dialog.classList.toggle('emberose-viewer-zoomed', !atFit());
      };
      new MutationObserver(updateStatus).observe(image, { attributes: true, attributeFilter: ['src'] });
      const atFit = () => !level || parseInt(level.textContent, 10) === 100;
      const updateGestureMode = () => { viewport.classList.toggle('emberose-swipe-surface', atFit()); updateStatus(); };
      updateGestureMode();
      if (level) new MutationObserver(updateGestureMode).observe(level, { childList: true, characterData: true, subtree: true });
      if (openers.length < 2) return;
      let previous = dialog.querySelector('[data-gallery-previous]');
      let next = dialog.querySelector('[data-gallery-next]');
      if (!previous || !next) {
        const controls = document.createElement('div');
        controls.className = 'emberose-gallery-pagination';
        const move = (direction) => {
          const current = openers.findIndex(opener => new URL(opener.dataset.image, document.baseURI).href === image.src);
          const index = (current + direction + openers.length) % openers.length;
          thumbs[panels.indexOf(openers[index].closest('.product-gallery__panel'))]?.click();
          openers[index].click();
        };
        const makeButton = (direction, label) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', label);
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', direction === 1 ? 'm9 5 7 7-7 7' : 'm15 5-7 7 7 7');
          icon.append(path);button.append(icon);
          button.addEventListener('click', () => move(direction));
          controls.append(button);return button;
        };
        previous = makeButton(-1, labels?.previousLabel || 'Previous image');
        next = makeButton(1, labels?.nextLabel || 'Next image');
        dialog.querySelector('.product-gallery__lightbox-shell').append(controls);
      }
      previous.classList.add('emberose-viewer-previous');
      next.classList.add('emberose-viewer-next');
      const move = direction => (direction === 1 ? next : previous).click();
      bindSwipe(viewport, move, () => dialog.open && atFit());
      dialog.addEventListener('keydown', (event) => {
        if (!atFit() || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();event.stopImmediatePropagation();move(event.key === 'ArrowRight' ? 1 : -1);
      }, true);
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
